module.exports = __webpack_public_path__ + "02_glasses_red.a39338da.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer4/02_glasses_red.png
// module id = pstz
// module chunks = 0